namespace B2B.UI {
    export class Popup {
        private _bg: PopupBackground;
        private _element: HTMLElement;
        private _content: HTMLElement;
        private _closeButton: HTMLAnchorElement;

        constructor() {
            this._bg = new B2B.UI.PopupBackground();

            this._element = document.createElement("div");
            this._element.classList.add("b-popup");
            this._closeButton = document.createElement("a");
            this._closeButton.classList.add("b-popup__close");
            this._element.appendChild(this._closeButton);
            this._closeButton.addEventListener("click", this.handleCloseButtonClick.bind(this), { capture: true });
        }

        public get element(){
            return this._element;
        }

        public setContent(content: HTMLElement) {
            if (this._content) {
                this._content.remove();
            }
            this._content = content;
        }

        public show() {
            if(!this._content){
                throw new Error("Content must be specified");
            }

            this._element.style.width = this._content.style.width;
            this._content.style.width = "100%";

            this._element.appendChild(this._content);

            this._bg.show(this._element);
        }

        private handleCloseButtonClick(e){
            this.close();
            e.preventDefault();
            e.stopPropagation();
        }

        protected onClose(){

        }

        public close() {
            this.hide();
            this.onClose();
        }

        protected hide() {
            if(this._bg) {
                this._bg.close();
            }
            //this._content.remove();
            //this._content = undefined;
        }
    }
}